import DocumentMapDataGeometry from "Areas/SharedFeatures/types/documentMapDataGeometry";
import DocumentMapDataPoint from "Areas/SharedFeatures/types/documentMapDataPoint";
import { MAP_GEOMETRY_TYPE } from "Common/dictionaries/mapGeometryType";
import map from "lodash/map";
import reverse from "lodash/reverse";
import some from "lodash/some";
import { fromLonLat, toLonLat } from "ol/proj";
import GeoFeature from "../types/geoFeature";
import GeoFeatureClusteredName from "../types/geoFeatureClusteredName";
import GeoFeatureClusteredPoint from "../types/geoFeatureClusteredPoint";
import GeoFeatureLineOrArea from "../types/geoFeatureLineOrArea";
export const buildPointToGeoFeatureClusteredName = (point) => {
    var _a, _b;
    if (!point || !point.NodeId)
        return undefined;
    const coordinates = fromLonLat([point.Longitude, point.Latitude]);
    if (some(coordinates, c => Number.isNaN(c)))
        return undefined;
    return new GeoFeatureClusteredName(point.Id, [coordinates], point.Name, (_b = (_a = point.NodeSource) === null || _a === void 0 ? void 0 : _a.Created) !== null && _b !== void 0 ? _b : 0);
};
export const buildGeometryToGeoFeatureClusteredName = (geometry) => {
    var _a;
    if (!geometry || !geometry.Id || geometry.MapGeometryType !== MAP_GEOMETRY_TYPE.POINT)
        return undefined;
    return new GeoFeatureClusteredName(geometry.Id, map(geometry.Points, point => fromLonLat(reverse(Array.from(point)))), geometry.Name, (_a = geometry.Created) !== null && _a !== void 0 ? _a : 0);
};
export const buildPointToGeoFeatureClusteredPoint = (point) => {
    var _a, _b, _c;
    if (!point || !point.NodeId)
        return undefined;
    const coordinates = fromLonLat([point.Longitude, point.Latitude]);
    if (some(coordinates, c => Number.isNaN(c)))
        return undefined;
    return new GeoFeatureClusteredPoint(point.Id, [coordinates], (_a = point.NodeSource) === null || _a === void 0 ? void 0 : _a.Color, (_c = (_b = point.NodeSource) === null || _b === void 0 ? void 0 : _b.Created) !== null && _c !== void 0 ? _c : 0);
};
export const buildGeometryToGeoFeatureClusteredPoint = (geometry) => {
    var _a;
    if (!geometry || !geometry.Id || geometry.MapGeometryType !== MAP_GEOMETRY_TYPE.POINT)
        return undefined;
    return new GeoFeatureClusteredPoint(geometry.Id, map(geometry.Points, point => fromLonLat(reverse(Array.from(point)))), geometry.Color, (_a = geometry.Created) !== null && _a !== void 0 ? _a : 0);
};
export const buildGeometryToGeoFeatureLineOrArea = (geometry) => {
    if (!geometry || !geometry.Id || geometry.MapGeometryType === MAP_GEOMETRY_TYPE.POINT)
        return undefined;
    const coordinates = map(geometry.Points, point => fromLonLat(reverse(Array.from(point))));
    return new GeoFeatureLineOrArea(geometry.Id, coordinates, geometry.MapGeometryType, geometry.Color, geometry.Name);
};
export const buildPointToGeoFeature = (point) => {
    var _a, _b, _c, _d;
    if (!point || !point.NodeId)
        return undefined;
    const coordinates = fromLonLat([point.Longitude, point.Latitude]);
    if (some(coordinates, c => Number.isNaN(c)))
        return undefined;
    return new GeoFeature(point.Id, [coordinates], MAP_GEOMETRY_TYPE.POINT, (_a = point.NodeSource) === null || _a === void 0 ? void 0 : _a.Color, point.NodeSource, point.Name, (_b = point.NodeSource) === null || _b === void 0 ? void 0 : _b.Description, (_d = (_c = point.NodeSource) === null || _c === void 0 ? void 0 : _c.Created) !== null && _d !== void 0 ? _d : 0);
};
export const buildGeometryToGeoFeature = (geometry) => {
    var _a, _b;
    if (!geometry || !geometry.Id || !((_a = geometry.Points) === null || _a === void 0 ? void 0 : _a.length))
        return undefined;
    const coordinates = map(geometry.Points, point => fromLonLat(reverse(Array.from(point))));
    return new GeoFeature(geometry.Id, coordinates, geometry.MapGeometryType, geometry.Color, null, geometry.Name, geometry.Description, (_b = geometry.Created) !== null && _b !== void 0 ? _b : 0);
};
export const buildGeoFeatureToDocumentMapDataGeometry = (geoFeature) => {
    var _a;
    if (!geoFeature || geoFeature.nodeSource)
        return undefined;
    return new DocumentMapDataGeometry(geoFeature.id, geoFeature.mapGeometryType, map(geoFeature.coordinates, coord => reverse(toLonLat(coord))), (_a = geoFeature.created) !== null && _a !== void 0 ? _a : 0, geoFeature.name, geoFeature.description, geoFeature.color);
};
export const buildGeoFeatureToDocumentMapDataPoint = (geoFeature) => {
    var _a;
    if (!geoFeature || !geoFeature.id || !geoFeature.nodeSource || !geoFeature.coordinates)
        return undefined;
    const points = toLonLat(geoFeature.coordinates[0]);
    return new DocumentMapDataPoint(geoFeature.id, points[1], points[0], geoFeature.name, (_a = geoFeature.nodeSource) === null || _a === void 0 ? void 0 : _a.NodeId, geoFeature.nodeSource);
};
